import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { RoutedSavableApp } from 'platform/forms/save-in-progress/RoutedSavableApp';
import {
  setFetchFormStatus,
  fetchInProgressForm,
} from 'platform/forms/save-in-progress/actions';
import { getSaveInProgressState } from 'platform/forms/save-in-progress/selectors';
import { mergeFormDataWithLiveResumeToggles } from '../utils';

/**
 * Applies live feature-toggle values when validating SIP returnUrl on new-session
 * resume so an invalid path does not fall back to the beginning of the form.
 */
class Form526RoutedSavableApp extends RoutedSavableApp {
  getSafeReturnUrl(props, returnUrl) {
    return super.getSafeReturnUrl(
      {
        ...props,
        formData: mergeFormDataWithLiveResumeToggles(props.formData),
      },
      returnUrl,
    );
  }
}

const ConnectedForm526RoutedSavableApp = connect(
  getSaveInProgressState,
  {
    setFetchFormStatus,
    fetchInProgressForm,
  },
)(Form526RoutedSavableApp);

export default withRouter(ConnectedForm526RoutedSavableApp);
